import React, { useEffect, useState } from 'react';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import { Fab } from '@mui/material';

import { isMobileSafari } from '../../../three/util/events/touch';

export function FullscreenFab() {
  const [isFullscreen, setIsFullscreen] = useState(() => document.fullscreenElement != null);

  useEffect(() => {
    function handleFullscreenChange() {
      setIsFullscreen(document.fullscreenElement != null);
    }

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => void document.removeEventListener('fullscreenchange', handleFullscreenChange);
  }, []);

  if (isFullscreen || isMobileSafari()) return null;

  return (
    <Fab
      color="primary"
      onClick={() => {
        try {
          document.body.requestFullscreen();
        } catch {
          // nom
        }
      }}
    >
      <FullscreenIcon />
    </Fab>
  );
}
